import React, { useState, useEffect } from "react";
import { Select, Input, message, Spin, Button, Table, Modal } from "antd";
import { http } from "../../../../services/http";
import { useTranslation } from "react-i18next";
import ShipProductModalEdit from "../../../../components/WhrManager/shipProductEdit";
import { getToday } from "../../../../utils/getDays";
import { CloseOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import moment from "moment";
import CarIcon from "../../../../assets/icons/CarIcons";
import CarIcon2 from "../../../../assets/icons/CarIconV2";
import LoadersIcon from "../../../../assets/icons/LoadersIcon";
import {
  driverPdfExact,
  driverPdf,
  loadersPdf,
} from "../../../../utils/navigateToPDF";
import { numberWithSpacesIntl } from "../../../../utils/numberWithSpaces";

const ShipProductModal = ({ datas, onClose, visible }) => {
  const { t } = useTranslation();
  const today = getToday();
  const employeeId = useSelector((state) => state.main.employeeId);

  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [loading4, setLoading4] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [driverId, setDriverId] = useState("");
  const [manager, setManager] = useState("");
  const [loaders, setLoaders] = useState([]);
  const [selectedLoadersAllData, setSelectedLoadersAllData] = useState([]);
  const [date, setDate] = useState(today);
  const [status, setStatus] = useState("");
  const [salesLoading, setSalesLoading] = useState(false);
  const [loaderBtnClicked, setLoaderBtnClicked] = useState(false); //Bunda agar oldin button bosilmagan bolsa Birinchi shu button bosiladi kyn shipData
  const [pdfData, setPdfData] = useState(null);
  const [carNumbers, setCarNumbers] = useState([]);
  const [loadingData, setLoadingData] = useState({
    ddata: false,
    wdata: false,
    mdata: false,
  });

  const [data, setData] = useState({
    ddata: [],
    value: "",
    wdata: [],
    mdata: [],
    loadersData: [],
  });

  const [salesData, setSalesData] = useState(null);
  const [docLines, setDocLines] = useState([]);

  const { ddata, loadersData } = data;

  const sum =
    salesData?.docCur === "UZS"
      ? new Intl.NumberFormat("fr-FR").format(salesData?.docTotalFC)
      : new Intl.NumberFormat("fr-FR").format(salesData?.docTotal);

  const [isCommentModalVisible, setIsCommentModalVisible] = useState(false);
  const [selectedComments, setSelectedComments] = useState("");
  const [onHandQuantityData, setOnHandQuantity] = useState(null);
  const [carNum, setCarNum] = useState("");
  const [loaderNames, setLoaderNames] = useState("");

  const fetchOnHandQuantity = async (itemCodes, fromWhs) => {
    try {
      const { data } = await http.get(
        `api/items/ombordagiitems/on-hand-items?itemCodes=${itemCodes}&whsCode=${fromWhs}`,
      );
      return data;
    } catch (error) {
      console.log("Error:", error.message);
    }
  };

  const handleSelectClick = () => {
    setSelectedComments(datas.comments);
    setIsCommentModalVisible(true);
  };

  const handleModalOk = () => {
    setIsCommentModalVisible(false);
  };

  const handleModalCancel = () => {
    setIsCommentModalVisible(false);
  };

  const handleWarehouseChange = (value, rowIndex) => {
    setDocLines((prev) => {
      const updatedData = [...prev];
      updatedData[rowIndex] = {
        ...updatedData[rowIndex],
        warehouseCode: value,
      };
      return updatedData;
    });
  };

  useEffect(() => {
    const fetchAllData = async () => {
      setLoadingData({ ddata: true, wdata: true, mdata: true });
      await Promise.all([
        fetchDrivers(),
        fetchWarehouse(),
        fetchResponsibleManagers(),
        fetchLoaders(),
        fetchCarNumbers(),
      ]);
      setLoadingData({ ddata: false, wdata: false, mdata: false });
    };
    fetchAllData();

    if (visible) {
      resetForm();
    }
  }, [visible]);

  useEffect(() => {
    if (datas) {
      const resData = datas;
      setManager(
        resData?.u_Responsible_Person
          ? Number(resData.u_Responsible_Person)
          : "",
      );
      setDriverId(resData.driver ? resData.driver : "");
      const status = resData.u_OrderStatus;
      setStatus(status);
      setSalesData(resData);
      setCarNum(resData?.u_CarNumber);
      getLoaders(resData?.u_DeliveryID);
      setPdfData(resData);
    }
    if (datas?.documentLines) {
      const itemCodes = datas.documentLines
        .map((item) => item.itemCode)
        .join(",");
      (async () => {
        const fetchedData = await fetchOnHandQuantity(
          itemCodes,
          datas?.documentLines[0]?.warehouseCode,
        );

        const mappedLines = datas.documentLines.map((item) => {
          const onHandItem = fetchedData.find(
            (fetchedItem) => fetchedItem.itemCode === item.itemCode,
          );

          return {
            ...item,
            whsOnHandQuantity: onHandItem ? onHandItem.onHand : 0,
            whsAvailableQuantity: onHandItem ? onHandItem.available : 0,
          };
        });

        setPdfData((prevState) => ({
          ...prevState,
          documentLines: mappedLines,
        }));
        console.log("mappedLines", mappedLines);

        setDocLines(mappedLines);
      })();
    }
  }, [datas]);

  const fetchDrivers = async () => {
    try {
      const { data } = await http.get(
        `api/sales/driver-business-partners?skip=0`,
      );

      setData((prevState) => ({
        ...prevState,
        ddata: data.data,
      }));
    } catch (err) {
      console.log(err);
    }
  };
  const fetchCarNumbers = async () => {
    try {
      const { data } = await http.get(
        `api/inventorytransferrequest/car-numbers`,
      );
      setCarNumbers(data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchResponsibleManagers = async () => {
    try {
      const { data } = await http.get(
        `api/sales/warehouse-employee-info?skip=0`,
      );

      setData((prevState) => ({
        ...prevState,
        mdata: data.data,
      }));
    } catch (err) {
      console.log(err);
    }
  };
  const fetchLoaders = async () => {
    try {
      const { data } = await http.get(
        `api/warehouseassistant/employee-business-partners?skip=0`,
      );

      setData((prevState) => ({
        ...prevState,
        loadersData: data.data,
      }));
    } catch (err) {
      console.log(err);
    }
  };

  const getLoaders = async (docEntry) => {
    if (!docEntry || docEntry === "" || docEntry === null) {
      setLoaders([]);
      setSelectedLoadersAllData([]);
      setLoaderBtnClicked(false);
      return;
    }
    setLoading(true);
    try {
      const { data } = await http.get(
        `api/deliverynotesdata/get-employees?docEntry=${docEntry}`,
      );
      const resData = data[0]?.documentLines || [];
      const loaders = resData?.map((item) => item?.employeeID) || []; //Bu Selecda getida kelganlar tanlanib qolishi uchun qilindi
      const loaderNames = resData?.map((item) => item?.employeeName).join(", ");
      const selectedDataLoaders = resData.map((item, index) => ({
        lineId: item.lineId,
        data: {
          cardCode: item.employeeID,
          cardName: item.employeeName,
        },
      })); // Bu Backendga jonatvotgan selectda shunaqa tartibda olinganakan shunichun yozildi bu
      setLoaders(loaders);
      setSelectedLoadersAllData(selectedDataLoaders);
      setLoaderBtnClicked(true);
      setPdfData((prevState) => ({
        ...prevState,
        loaderNames: loaderNames,
      }));
      console.log("loaderNames", loaderNames);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchWarehouse = async () => {
    try {
      const { data } = await http.get(`api/warehouses`);
      const mappedItems = data
        .filter((item) => item.warehouseCode !== "01")
        .map((item) => ({
          code: item.warehouseCode,
          name: item.warehouseName,
        }));
      setData((prevState) => ({
        ...prevState,
        wdata: mappedItems,
      }));
    } catch (err) {
      console.log(err);
    }
  };

  const editManager = async () => {
    if (manager) {
      setLoading(true);

      try {
        await http.patch(
          `api/sales/responsible-person/${datas.docEntry}?responsiblePerson=${manager}`,
        );
        message.success(t("sucEditedManager"));
      } catch (error) {
        message.error(t("errCreation") + error.message);
      } finally {
        setLoading(false);
      }
    } else {
      message.error(t("selectResponsible"));
    }
  };

  const confirmDelivery = async () => {
    setLoading3(true);
    const dataArray = docLines.map((item) => ({
      lineNumber: item.lineNum,
      // itemCode: item.itemCode,
      warehouseCode: item.warehouseCode,
    }));

    try {
      await http.patch(`api/sales/confirmed/${datas.docEntry}`, [...dataArray]);
      message.success(t("sucCreated"));

      setTimeout(() => {
        resetForm();
        onClose();
      }, 100);
    } catch (error) {
      message.error(error.response.data.message || error.message);
    } finally {
      setLoading3(false);
    }
  };
  const postLoaders = async () => {
    setLoading4(true);

    const orderDeliveryCollection = selectedLoadersAllData.map(
      (item, index) => ({
        lineId: index + 1,
        employeeId: item.data.cardCode,
        employeeName: item.data.cardName,
      }),
    );

    const postingData = {
      createDate: moment().format("YYYY-MM-DD"),
      orderDeliveryCollection,
    };

    try {
      await http.post(
        `/api/warehouseassistant/create-order-delivery/${datas.docEntry}`,
        postingData,
      );
      message.success(t("sucCreated"));
      setLoaderBtnClicked(true);
      setTimeout(() => {
        resetForm();
        onClose();
      }, 100);
    } catch (error) {
      message.error(error.response.data.message || error.message);
    } finally {
      setLoading4(false);
    }
  };

  const patchLoaders = async () => {
    setLoading4(true);
    const employeeLines = selectedLoadersAllData.map((item, index) => ({
      lineId: index + 1,
      employeeId: item.data.cardCode,
      employeeName: item.data.cardName,
    }));

    const postingData = {
      docEntry: datas?.u_DeliveryID,
      employeeLines,
    };

    try {
      await http.patch(
        `/api/inventorytransferrequest/employee/delivery/${datas?.u_DeliveryID}`,
        postingData,
      );
      message.success(t("sucEdit"));
      setLoaderBtnClicked(true);
      setTimeout(() => {
        resetForm();
        onClose();
      }, 100);
    } catch (error) {
      message.error(error.response.data.message || error.message);
    } finally {
      setLoading4(false);
    }
  };

  const handleLoaderAttachBtnClick = async () => {
    if (loaderBtnClicked) {
      patchLoaders();
    } else {
      postLoaders();
    }
  };

  const editDriver = async () => {
    if (driverId) {
      setLoading2(true);

      try {
        await http.patch(
          `api/sales/driver/${datas.docEntry}?carNumber=${carNum}&driver=${driverId}`,
        );
        message.success(t("sucEditedDriverAndCarNum"));
        setTimeout(() => {
          resetForm();
          onClose();
        }, 100);
      } catch (error) {
        message.error(error?.response?.data?.message);
      } finally {
        setLoading2(false);
      }
    } else {
      message.error(t("selectDriver"));
    }
  };

  const editStatus = async () => {
    setLoading4(true);

    try {
      await http.patch(`api/sales/assigned/${datas.docEntry}`);
      message.success(t("sucCreated"));

      setTimeout(() => {
        resetForm();
        onClose();
      }, 800);
    } catch (error) {
      message.error(t("errCreation") + error.message);
    } finally {
      setLoading4(false);
    }
  };

  const onEdit = async () => {
    setIsModalVisible(true);
  };

  const resetForm = () => {
    setData((prevState) => ({
      ...prevState,
      value: "",
      managerId: "",
    }));
  };

  if (!salesData) return null;

  const columns = [
    {
      title: t("item"),
      dataIndex: "itemDescription",
      key: "itemDescription",
      width: 280,
      render: (text, record, index) => {
        return (
          <span
            className={`${record.lineStatus === "C" ? "text-slate-500" : "text-black"}`}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: t("onHand"),
      dataIndex: "whsOnHandQuantity",
      key: "whsOnHandQuantity",

      render: (text, record, index) => {
        const formattedText = new Intl.NumberFormat("fr-FR").format(text);
        return (
          <span
            className={`${record.lineStatus === "C" ? "text-slate-500" : "text-black"}`}
          >
            {formattedText}
          </span>
        );
      },
    },
    {
      title: t("quantity"),
      dataIndex: "quantity",
      key: "quantity",

      render: (text, record, index) => {
        const formattedText = new Intl.NumberFormat("fr-FR").format(text);
        return (
          <span
            className={`${record.lineStatus === "C" ? "text-slate-500" : "text-black"}`}
          >
            {formattedText}
          </span>
        );
      },
    },

    {
      title: t("unitMsr"),
      dataIndex: "measureUnit",
      key: "measureUnit",
      text: "center",
      render: (text, record, index) => {
        return (
          <span
            className={`${record.lineStatus === "C" ? "text-slate-500" : "text-black"} text-center`}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: t("price"),
      dataIndex: "price",
      key: "price",
      render: (text, record, index) => {
        const formattedText = new Intl.NumberFormat("fr-FR").format(text);
        return (
          <span
            className={`${record.lineStatus === "C" ? "text-slate-500" : "text-black"}`}
          >
            {formattedText} {record.currency}
          </span>
        );
      },
    },
    {
      title: t("weight"),
      dataIndex: "weight",
      key: "weight",
      width: 100,
      render: (text, record, index) => {
        return (
          <span
            className={`${record.lineStatus === "C" ? "text-slate-500" : "text-black"}`}
          >
            {`${numberWithSpacesIntl(text * record.quantity)} кг`}
          </span>
        );
      },
    },
    {
      title: t("Hajmi"),
      dataIndex: "volume",
      key: "volume",
      render: (text, record, index) => {
        return (
          <span
            className={`${record.lineStatus === "C" ? "text-slate-500" : "text-black"}`}
          >
            {`${numberWithSpacesIntl(text * record.quantity)} `}
          </span>
        );
      },
    },
    {
      title: t("packageQty"),
      dataIndex: "packageQty",
      key: "packageQty",
      render: (text, record, index) => {
        let packageQty;
        if (!record.packageQty || record.packageQty > record.quantity) {
          packageQty = 0;
        } else {
          packageQty = record.quantity / record.packageQty;
        }
        return (
          <span
            className={`${record.lineStatus === "C" ? "text-slate-500" : "text-black"}`}
          >
            {`${numberWithSpacesIntl(packageQty.toFixed(1))} `}
          </span>
        );
      },
    },
    {
      title: t("packageType"),
      dataIndex: "packageType",
      key: "packageType",
    },
    {
      title: t("totalMiqdor"),
      dataIndex: "lineTotal",
      key: "lineTotal",
      render: (text, record) => {
        const formatSum =
          record.currency === "UZS"
            ? new Intl.NumberFormat("fr-FR").format(record?.totalFrgn)
            : new Intl.NumberFormat("fr-FR").format(text);
        return (
          <span
            className={`${record.lineStatus === "C" ? "text-slate-500" : "text-black"}`}
          >
            {`${formatSum} ${record.currency}`}
          </span>
        );
      },
    },
  ];

  const tableData = docLines;

  const finishSale = async () => {
    setLoading(true);
    try {
      console.log("datas.dueDate", datas.docDueDate);
      const documentLines = tableData
        .filter((item) => item.quantity !== 0)
        .map((item) => ({
          baseEntry: datas?.docEntry,
          baseType: 17,
          baseLine: item.lineNum,
          itemCode: item.itemCode,
          quantity: item.quantity,
          warehouseCode: item.warehouseCode,
          price: +item.price,
          currency: item.currency,
        }));

      await http.post("api/yakunlangansotuvlar", {
        cardCode: String(datas?.cardCode),
        u_Driver: driverId || "",
        U_CarNumber: carNum || "",
        u_Father_DocNum: datas?.u_Father_DocNum || "",
        u_Responsible_Person: null,
        salesPersonCode: null,
        documentsOwner: employeeId,
        docCurrency: datas?.docCur,
        docDueDate: datas.docDueDate,
        docDate: date,
        u_DeliveryID: datas?.u_DeliveryID || "",
        documentLines: documentLines,
      });
      message.success(t("sucCreated"));

      setTimeout(() => {
        onClose();
      }, 800);
    } catch (error) {
      message.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        <h1 className="font-nunito text-xl font-extrabold text-[#000000]">
          {t("order")} № {datas.docNum}
        </h1>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      closeIcon={<CloseOutlined />}
      width="85%"
      style={{ height: "70%" }}
      loading={salesLoading}
      styles={{ height: "calc(100% - 55px)", overflowY: "auto" }}
    >
      <div className="w-full overflow-x-auto">
        <div id="ship-product-form" className="w-full">
          <div className="mt-10 flex flex-col items-start justify-between gap-4 sm:flex-row">
            <div className="flex flex-col gap-5">
              <div className="flex w-full flex-col gap-2 sm:w-auto">
                <p className="font-nunito">{t("mijoz")}</p>
                <Input
                  type="text"
                  value={datas.cardName}
                  className="flex h-10 w-full items-center justify-center font-bold text-black sm:w-[400px]"
                  style={{ color: "black" }}
                  disabled
                />
              </div>
              <div className="flex w-full flex-col gap-2 sm:w-auto">
                <p className="font-nunito">{t("agent")}</p>
                <Input
                  type="text"
                  value={datas.slpName}
                  className="flex h-10 w-full items-center justify-center font-bold text-black sm:w-[400px]"
                  style={{ color: "black" }}
                  disabled
                />
              </div>
              <div className="flex w-full flex-col gap-2 sm:w-auto">
                <p className="font-nunito">{t("whs")}</p>
                <Input
                  type="text"
                  value={`${tableData[0]?.whsName} - ${tableData[0]?.warehouseCode}`}
                  className="flex h-10 w-full items-center justify-center font-bold text-black sm:w-[400px]"
                  style={{ color: "black" }}
                  disabled
                />
              </div>
            </div>
            <div className="flex w-full flex-col gap-3 sm:w-auto">
              <div className="flex w-full flex-col gap-2 sm:w-auto">
                <p className="font-nunito">{t("createdDate")}</p>

                <Input
                  type="text"
                  value={moment(datas.docDate).format("DD.MM.YYYY")}
                  style={{ color: "black" }}
                  disabled
                />
              </div>
              <div className="flex w-full flex-col gap-2 sm:w-auto">
                <p className="font-nunito">{t("shippingDate")}</p>

                <Input
                  type="text"
                  value={moment(datas.docDueDate).format("DD.MM.YYYY")}
                  style={{ color: "black" }}
                  disabled
                />
              </div>
            </div>
          </div>

          <Table
            columns={columns}
            dataSource={tableData}
            pagination={false}
            className="border-1 mt-12 overflow-x-auto border-black"
          />

          <div className="mt-10 flex items-start justify-between">
            <div className="flex flex-col gap-3">
              <p>{t("comments")}</p>
              <Input.TextArea
                rows={4}
                value={datas.comments}
                className="flex h-10 w-full items-center justify-center font-bold text-black sm:w-[350px]"
                style={{ color: "black" }}
                disabled
                // onClick={handleSelectClick}
              />
              {/* <Modal
                title={t("comments")}
                visible={isCommentModalVisible}
                onOk={handleModalOk}
                onCancel={handleModalCancel}
              >
                <p>{selectedComments}</p>
              </Modal> */}
            </div>
            <div className="flex flex-col items-center justify-end gap-5">
              <div className="flex gap-3">
                <div className="flex flex-col gap-3">
                  <p>{t("totalVolume")}</p>
                  <Input
                    type="text"
                    value={`${numberWithSpacesIntl(
                      tableData.reduce((total, item) => {
                        return total + item.volume * item.quantity;
                      }, 0),
                    )} `}
                    style={{ color: "black" }}
                    className="flex h-10 w-full items-center justify-center border-[1px] border-[#D0D0D0] font-bold text-black active:border-[#D0D0D0] sm:w-[200px]"
                    disabled
                  />
                </div>

                <div className="flex flex-col gap-3">
                  <p>{t("totalWeight")}</p>
                  <Input
                    type="text"
                    value={`${numberWithSpacesIntl(
                      tableData.reduce((total, item) => {
                        return total + item.weight * item.quantity;
                      }, 0),
                    )} кг`}
                    style={{ color: "black" }}
                    className="flex h-10 w-full items-center justify-center border-[1px] border-[#D0D0D0] font-bold text-black active:border-[#D0D0D0] sm:w-[200px]"
                    disabled
                  />
                </div>
              </div>
              <div className="flex gap-3">
                <div className="flex flex-col gap-3">
                  <p>{t("docTotalQuantity")}</p>
                  <Input
                    type="text"
                    value={`${new Intl.NumberFormat("fr-FR").format(
                      salesData?.documentLines.reduce((total, item) => {
                        return total + item.inventoryQuantity;
                      }, 0),
                    )} ${tableData[0]?.measureUnit}`}
                    style={{ color: "black" }}
                    className="flex h-10 w-full items-center justify-center border-[1px] border-[#D0D0D0] font-bold text-black active:border-[#D0D0D0] sm:w-[200px]"
                    disabled
                  />
                </div>

                <div className="flex flex-col gap-3">
                  <p>{t("totalPrice")}</p>
                  <Input
                    type="text"
                    value={`${sum} ${salesData.docCur}`}
                    style={{ color: "black" }}
                    className="flex h-10 w-full items-center justify-center border-[1px] border-[#D0D0D0] font-bold text-black active:border-[#D0D0D0] sm:w-[200px]"
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="mt-10 flex flex-col items-start justify-between gap-4 sm:flex-row">
            <div className="flex flex-col items-center justify-end gap-5">
              {/* <div className="flex flex-col gap-3">
                <p>{t("responsiblePerson")}</p>
                <Spin spinning={loadingData.mdata}>
                  <Select
                    value={manager}
                    placeholder={t("chooseManager")}
                    onChange={(val) => {
                      setManager(val);
                    }}
                    // disabled={salesData?.u_OrderStatus !== "Tasdiqlandi"}
                    showSearch
                    className="flex h-10 w-full items-center justify-center sm:w-[300px]"
                  >
                    {mdata
                      .filter((item) => item.firstName !== null)
                      .map((item) => (
                        <Select.Option key={item.value} value={item.employeeId}>
                          {`${item.firstName} ${item.lastName}`}
                        </Select.Option>
                      ))}
                  </Select>
                </Spin>
              </div> */}
              <div className="flex flex-col gap-3">
                <p>{t("loaders")}</p>
                <Spin spinning={loadingData.mdata}>
                  <Spin spinning={loadingData.mdata}>
                    <Select
                      mode="multiple"
                      value={loaders}
                      placeholder={t("loaders")}
                      onChange={(val, label) => {
                        setLoaders(val);
                        setSelectedLoadersAllData(label);
                        console.log("Loaders", val, label);
                      }}
                      showSearch
                      style={{ width: "100%", minHeight: "40px" }}
                      className="min-h-10 max-w-[300px]"
                    >
                      {loadersData.map((item) => (
                        <Select.Option
                          key={item.cardCode}
                          value={item.cardCode}
                          data={item}
                          label={item.cardName}
                          lineId={
                            selectedLoadersAllData[
                              selectedLoadersAllData.length - 1
                            ]?.lineId + 1 || 1
                          }
                        >
                          {item.cardName}
                        </Select.Option>
                      ))}
                    </Select>
                  </Spin>
                </Spin>
              </div>
              <div className="flex items-center gap-3">
                <Button
                  onClick={handleLoaderAttachBtnClick}
                  loading={loading4}
                  className={`h-12 w-full rounded-3xl bg-[#0A4D68] text-white sm:w-auto ${loaders.length > 0 && "!bg-yellow-100 !text-yellow-600"}`}
                >
                  {t("patchLoader")}
                </Button>
              </div>
            </div>
            {/* <div className="flex flex-col gap-3">
              <p>{t("loaders")}</p>
              <Spin spinning={loadingData.mdata}>
                <Spin spinning={loadingData.mdata}>
                  <Select
                    mode="multiple"
                    value={loaders}
                    placeholder={t("loaders")}
                    onChange={(val, label) => {
                      setLoaders(val);
                      setSelectedLoadersAllData(label);
                      console.log("Loaders", val, label);
                    }}
                    showSearch
                    style={{ width: "100%", minHeight: "40px" }}
                    className="min-h-10 max-w-[400px]"
                  >
                    {loadersData.map((item) => (
                      <Select.Option
                        key={item.cardCode}
                        value={item.cardCode}
                        data={item}
                        label={item.cardName}
                      >
                        {item.cardName}
                      </Select.Option>
                    ))}
                  </Select>
                </Spin>
              </Spin>
            </div> */}

            <div className="flex flex-col gap-5">
              <div className="flex w-full flex-col gap-3 sm:w-auto">
                <p>{t("driver")}</p>
                <Spin spinning={loadingData.ddata}>
                  <Select
                    value={driverId}
                    placeholder={t("chooseDriver")}
                    onChange={(val) => {
                      setDriverId(val);
                    }}
                    showSearch
                    className="flex h-10 w-full items-center justify-center sm:w-[250px]"
                  >
                    {ddata.map((item) => (
                      <Select.Option key={item.value} value={item.cardCode}>
                        {item.cardName}
                      </Select.Option>
                    ))}
                  </Select>
                </Spin>
              </div>
              <div className="flex w-full flex-col gap-3 sm:w-auto">
                <p>{t("carNumber")}</p>
                <Spin spinning={loadingData.ddata}>
                  <Select
                    value={carNum}
                    placeholder={t("chooseCar")}
                    onChange={(val) => {
                      setCarNum(val);
                    }}
                    showSearch
                    className="flex h-10 w-full items-center justify-center sm:w-[250px]"
                  >
                    {carNumbers.map((item) => (
                      <Select.Option key={item.fldValue} value={item.fldValue}>
                        {item.fldValue}
                      </Select.Option>
                    ))}
                  </Select>
                </Spin>
              </div>
              <div className="flex w-full items-center justify-center gap-3 sm:w-auto">
                <Button
                  onClick={editDriver}
                  // disabled={loading2 || salesData?.u_OrderStatus !== "Tasdiqlandi"}
                  loading={loading2}
                  className={`h-12 w-full rounded-3xl bg-[#0A4D68] text-white sm:w-auto ${datas?.driver && "!bg-green-100 !text-green-600"}`}
                >
                  {t("assignDriver")}
                </Button>
              </div>
            </div>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <Button
            type="default"
            onClick={() => {
              driverPdf({ data: pdfData });
            }}
            disabled={
              !pdfData ||
              !datas?.driver ||
              !datas?.u_CarNumber ||
              !loaders ||
              !pdfData?.loaderNames ||
              !loaders.length
            }
            className="h-10 rounded-lg bg-green-500 text-white hover:!bg-green-600 sm:w-auto"
          >
            <CarIcon />
          </Button>
          <Button
            type="default"
            onClick={() => {
              driverPdfExact({ data: pdfData });
            }}
            disabled={
              !pdfData ||
              !datas?.driver ||
              !datas?.u_CarNumber ||
              !loaders ||
              !pdfData?.loaderNames ||
              !loaders.length
            }
            className="h-10 rounded-lg bg-green-500 text-white hover:!bg-green-600 sm:w-auto"
          >
            <CarIcon2 />
          </Button>

          <Button
            type="default"
            onClick={() => {
              loadersPdf({ data: pdfData });
            }}
            disabled={
              !pdfData || !pdfData?.loaderNames || !loaders || !loaders.length
            }
            className="h-10 rounded-lg bg-yellow-500 text-white hover:!bg-yellow-600 sm:w-auto"
          >
            <LoadersIcon />
          </Button>
        </div>

        {/* <div className="flex flex-col gap-3 sm:mt-10">
          <div className="flex items-center gap-2">
            <span className="font-bold">{t("statusSale")} : </span>

            <Tag className="text-sm" color={"blue"}>
              {status}
            </Tag>
          </div>
          <div className="flex items-center gap-2">
            <span className="font-bold">{t("timeRp")} : </span>

            {salesData?.u_OrderToDeliveryTime && (
              <Tag className="text-sm" color={"blue"}>
                {salesData?.u_OrderToDeliveryTime}
              </Tag>
            )}
          </div>
          <div className="flex items-center gap-2">
            <span className="font-bold">{t("deliveredTime2")} : </span>
            {salesData?.u_OrderDeliveredTime && (
              <Tag className="text-sm" color={"blue"}>
                {salesData?.u_OrderDeliveredTime}
              </Tag>
            )}
          </div>
        </div> */}

        <div className="mt-10 flex flex-col flex-wrap items-start justify-between gap-5 sm:flex-row">
          {/* <Button
            onClick={editManager}
            className="h-12 w-full rounded-3xl bg-[#0A4D68] text-white sm:w-auto"
            disabled={loading || salesData?.u_OrderStatus !== "Tasdiqlandi"}
            loading={loading}
          >
            {t("assignToResponsible")}
          </Button> */}

          <Button
            onClick={onEdit}
            disabled={datas?.driver}
            className="h-12 w-full rounded-3xl bg-[#0A4D68] text-white sm:w-auto"
          >
            {t("edit")}
          </Button>

          <Button
            onClick={confirmDelivery}
            // disabled={
            // loading3 || salesData?.u_OrderStatus !== "BuyurtmaYuklandi"
            // }
            loading={loading3}
            disabled={
              loading3 ||
              !driverId ||
              !carNum ||
              loaders.length === 0 ||
              !datas?.driver ||
              !datas?.u_CarNumber ||
              true
            }
            className="h-12 w-full rounded-3xl bg-[#0A4D68] text-white sm:w-auto"
          >
            {t("confirmDelivery")}
          </Button>
          {/* <Button
            onClick={editStatus}
            // disabled={
            // loading4 || !manager || !driverId
            // salesData?.u_OrderStatus === "BuyurtmaYuklandi"
            // }
            loading={loading4}
            className="h-12 w-full rounded-3xl bg-[#0A4D68] text-white sm:w-auto"
          >
            {t("attach")}
          </Button> */}

          <Button
            onClick={finishSale}
            className="h-12 w-auto rounded-3xl bg-[#0A4D68] text-white"
            loading={loading}
            disabled={
              loading ||
              data?.docStatus === "C" ||
              !driverId ||
              loaders.length === 0 ||
              !carNum ||
              !datas?.u_CarNumber ||
              !datas?.driver ||
              !pdfData?.loaderNames
            }
          >
            {t("finishSale")}
          </Button>
        </div>
        <ShipProductModalEdit
          visible={isModalVisible}
          data={datas}
          onClose={() => setIsModalVisible(false)}
        />
      </div>
    </Modal>
  );
};

export default ShipProductModal;
